import service from '@/service'

/**
 * This service provide a API client that supports aborting of previous request, if it is invoked again before receiving response of previous API call. This is generally helpful in usecases like - dynamic search to make sure that latest API response is consumed always.
 * @constructor
 */
function AbortableAPIClient() {
  this.isPending = false
}

AbortableAPIClient.prototype.get = function(url, { params }) {
  if (this.isPending) {
    this.controller.abort()
  }
  this.controller = new AbortController()
  this.isPending = true
  return service.client
    .get(url, {
      params,
      signal: this.controller.signal
    })
    .finally(() => {
      this.isPending = false
    })
}

export default AbortableAPIClient
